'use strict';

window.getConfiguration = function() {
  return window.SERVER;
};

window.getConfigurationDescription = function() {
  return window.location.hostname.split('.')[0] || 'Server';
};

const API_VERSION = 'v1/';

angular.module('webAgro1App').factory('LoginService', function($http) {
  return {
    authenticate: function(login) {
      const payload = {
        username: (login.nome || '').toUpperCase(),
        password: (login.senha || '').toUpperCase()
      };
      return $http.post(`${SERVER + API_VERSION }login`, payload);
    }
  };
});
